export const SET_ONBOARDING_HEADER_STEPS = 'SET_ONBOARDING_HEADER_STEPS'

export const RESET_ONBOARDING_HEADER_STEPS = 'RESET_ONBOARDING_HEADER_STEPS'
